import {Link as SailLink} from '@sail/ui';

const DOTTED_STYLES = {
  textDecoration: 'underline',
  textDecorationStyle: 'dotted',
  ':hover': {
    textDecorationStyle: 'dotted',
  },
};

export const Link = ({children, ...props}: Parameters<typeof SailLink>[0]) => {
  const {css, type} = props;
  const dottedStyles = type === 'secondary' ? DOTTED_STYLES : {};

  return (
    <SailLink
      {...props}
      css={{
        color: 'inherit',
        ...dottedStyles,
        ...css,
      }}
    >
      {children}
    </SailLink>
  );
};
